import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useHistory } from "react-router-dom";

import { DialogConfirm } from "../../../components/DialogService/DialogService";
import { InputTextarea } from "primereact/inputtextarea";
import { Loading } from "../../../components/Loading/Loading";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { dataUserSession } from "../../../utilities/dataSession";
import { RadioButton } from "primereact/radiobutton";
import { FooterButtonSigle, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";

//PAGE
import P201List from "./P201List";

//SERVICE
import { pSupervisorRequest1_Info, pSupervisorRequest1_update } from "../../../service/200/P201Service";
import { genForemanList } from "../../../service/GEN/GenService";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P201() {
    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);

    const [searchData, setSearchData] = useState({
        requestNo: "",
        requestTypeDesc: "",
        contractNo: "",
        routeName: "",
        userId: "",
    });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [dropdownItem, setDropdownItem] = useState(null);
    const [formObject, setFormObject] = useState({
        displayMode: "", requestNo: "", requestType: "",
        contractNo: "", routeNo: "", locationBegin: 0, locationEnd: 0,
        operateDate: "", operateTimeBegin: "", operateTimeEnd: "", foreman: "",
        supervisorReason: "", recordStamp: 0, requestCategory: "1"
    });
    const [dataObjTb, setDataObjTb] = useState([]);

    //Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => { },
        onCancle: () => { },
        footerBtn: () => { },
    });

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({
                    ...searchData,
                    ...history.location.state,
                    userId: dataUserSession().userId,
                });
            } else {
                // setSearchData({
                //     requestNo: "R651600195",
                //     userId: dataUserSession().userId,
                // });

                history.push("/200");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData.requestNo !== "") onSupervisorRequest1_Info();
    }, [searchData]);

    const getGenForemanList = (contractNo) => {
        const req = { contractNo: contractNo, userId: searchData.userId };
        genForemanList(req).then(
            (res) => {
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.foremanFullName != null) arr.push({ name: item.foremanFullName, code: item.foremanId });
                    });
                    setDropdownItem(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onSupervisorRequest1_Info = () => {
        setLoading(true);
        const req = {
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };

        pSupervisorRequest1_Info(req).then(
            (res) => {
                // console.log(res);
                setLoading(false);
                if (res.status === 200) {
                    if (res.data.length > 0 && res.data[0] !== null) {
                        const _data = res.data[0];
                        setFormObject({
                            ...formObject,
                            displayMode: _data.displayMode,
                            requestNo: _data.requestNo,
                            requestType: _data.requestType,
                            contractNo: _data.contractNo,
                            routeName: _data.routeName,
                            foreman: _data.foreman,
                            locationBegin: _data.locationBegin,
                            locationEnd: _data.locationEnd,
                            operateDate: _data.operateDate,
                            operateTimeBegin: _data.operateTimeBegin,
                            operateTimeEnd: _data.operateTimeEnd,
                            supervisorReason: _data.supervisorReason,
                        });
                        getGenForemanList(_data.contractNo);
                        setDataObjTb(res.data);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const validation = (object) => {
        if (object.supervisorReason === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };
    const handlerSubmit = (act) => {
        setLoading(true);
        const req = {
            actionCode: act,
            requestNo: formObject.requestNo,
            supervisorReason: formObject.supervisorReason,
            userId: searchData.userId,
            recordStamp: formObject.recordStamp,
        };
        // console.log(req);
        pSupervisorRequest1_update(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    const _alert = res.data[0];
                    setdialogOption({
                        ...dialogOption,
                        header: "",
                        content: _alert.statusText,
                        footerBtn: () => footerButtonSingle(),
                    });
                    setConfirmDialog({ open: true });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const submitForm = (act) => {
        if (act == "R") {
            if (validation(formObject)) {
                handlerSubmit(act);
            }
        } else {
            handlerSubmit(act);
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const handlerBackPage = () => {
        history.push(`/200`);
    };

    const footerButtonSingle = () => {
        return <FooterButtonSigle btnLabel="ปิด" onClick={() => handlerBackPage()} />;
    };

    const footerButtonCon = (act) => {
        return (
            <FooterButtonCustomLabel
                labelCon="ยืนยัน"
                lableCan="ยกเลิก"
                onClickOk={() => {
                    submitForm(act);
                    setConfirmDialog({ open: false });
                }}
                onClickCancle={() => setConfirmDialog(false)}
            />
        );
    };
    const handlerSettingDialogConfirm = (key, _content) => {
        if (key === "R") {
            if (!validation(formObject)) {
                return true;
            }
        }
        setdialogOption({
            ...dialogOption,
            header: "",
            content: _content,
            footerBtn: () => footerButtonCon(key),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const disPlayMode = () => {
        // return false;
        return formObject.displayMode === "N" ? false : true;
    };

    const disPlayMode_R = () => {
        // return false;
        if (formObject.displayMode === "Y") {
            return true;
        } else {
            if (formObject.supervisorReason === "") {
                return true;
            } else {
                return false;
            }
        }
    };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">บันทึกอนุมัติ/ไม่อนุมัติ งานใหม่</h2>
                        <hr /> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เลขที่ใบแจ้งฯ</label>
                                <InputText id="requestNo" type="text" placeholder="ระบุ เลขที่ใบแจ้งฯ" disabled={true} maxLength="20" value={searchData.requestNo} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestType">ประเภทงาน</label>
                                <InputText id="requestType" type="text" placeholder="ระบุ ประเภทงาน" disabled={true} maxLength="100" value={searchData.requestTypeDesc} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" placeholder="ระบุ เลขที่สัญญา" disabled={true} maxLength="20" value={searchData.contractNo} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeName">เส้นทาง</label>
                                <InputText id="routeName" type="text" placeholder="ระบุ เส้นทาง" disabled={true} maxLength="5" value={searchData.routeName} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                    <RadioButton
                                        inputId="requestCategory"
                                        name="requestCategory"
                                        value="1"
                                        onChange={(e) => setFormObject({ ...formObject, requestCategory: e.value })}
                                        checked={formObject.requestCategory === "1"}

                                    />
                                    <label htmlFor="requestCategory" style={{ marginRight: ".5rem" }}>
                                        ปฏิบัติงาน
                                    </label>
                                    <RadioButton
                                        inputId="requestCategory"
                                        name="requestCategory"
                                        value="2"
                                        onChange={(e) => setFormObject({ ...formObject, requestCategory: e.value })}
                                        checked={formObject.requestCategory === "2"}

                                    />
                                    <label htmlFor="requestCategory" style={{ marginRight: ".5rem" }}>
                                        ตรวจสอบหน้างาน
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Begin list Table */}
                        {formObject.requestCategory === "1" && (
                            <P201List dataTable={dataObjTb} />
                        )}

                        {/* End List Table */}
                        <br />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationBegin">บริเวณก่อสร้าง</label>
                                {/* <InputNumber id="locationBegin" type="text" value={formObject.locationBegin} useGrouping={false} minFractionDigits={3} maxFractionDigits={3} mode="decimal" disabled={true} /> */}
                                <InputText id="locationBegin" type="text" disabled={true} maxLength="11" value={formObject.locationBegin} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationEnd">ถึง</label>
                                {/* <InputNumber id="locationEnd" type="text" value={formObject.locationEnd} useGrouping={false} minFractionDigits={3} maxFractionDigits={3} mode="decimal" disabled={true} /> */}
                                <InputText id="locationEnd" type="text" disabled={true} maxLength="11" value={formObject.locationEnd} />
                            </div>
                        </div>
                        {/* <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateDate">วันที่</label>
                                <InputText id="operateDate" type="text" value={formObject.operateDate == "" ? "" : formatDateTH(formObject.operateDate)} placeholder="ระบุ วันที่" disabled={true} />
                            </div>
                        </div> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeBegin">วันที่เวลาขอออกปฏิบัติงานจาก</label>
                                <InputText id="operateTimeBegin" type="text" placeholder="ระบุ ช่วงเวลาจาก" disabled={true} value={formObject.operateTimeBegin} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeEnd">วันที่เวลาขอออกปฏิบัติงานถึง</label>
                                <InputText id="operateTimeEnd" type="text" placeholder="ระบุ ถึง" disabled={true} value={formObject.operateTimeEnd} />
                            </div>
                        </div>
                        {/* <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtBegin">วันที่เวลาออกปฏิบัติงานจาก</label>
                                <InputText id="reportDtBegin" type="text" placeholder="ระบุ ช่วงเวลาจาก" disabled={true} value={formObject.reportDtBegin} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtEnd">วันที่เวลาออกปฏิบัติงานถึง</label>
                                <InputText id="reportDtEnd" type="text" placeholder="ระบุ ถึง" disabled={true} value={formObject.reportDtEnd} />
                            </div>
                        </div> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="foreman">หัวหน้างาน</label>
                                <Dropdown id="foreman" value={formObject.foreman} onChange={(e) => setFormObject({ ...formObject, foreman: e.value })} options={dropdownItem} optionLabel="name" optionValue="name" placeholder="เลือก หัวหน้างาน" disabled={true}></Dropdown>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="supervisor_reason">เหตุผล</label>
                                <span style={{ color: "red" }}>*</span>
                                <InputTextarea
                                    id="supervisorReason"
                                    className={submitted && !formObject.supervisorReason ? "p-invalid" : ""}
                                    rows="4"
                                    style={{ width: "100%" }}
                                    placeholder="ระบุ เหตุผล"
                                    value={formObject.supervisorReason}
                                    onChange={(e) => setFormObject({ ...formObject, supervisorReason: e.target.value })}
                                    disabled={disPlayMode()}
                                />
                                {submitted && !formObject.supervisorReason && validateInputText("supervisorReason", "เหตุผล")}
                            </div>
                        </div>
                        <br />
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button" icon="pi pi-check" label="อนุมัติ" style={{ width: 170 }} onClick={() => handlerSettingDialogConfirm("A", "ต้องการอนุมัติใบแจ้งฯ หรือไม่")} disabled={disPlayMode()} />
                                <Button className="p-button-warning p-button" icon="pi pi-ban" label="ไม่อนุมัติ" style={{ width: 170, marginLeft: "5px" }} onClick={() => handlerSettingDialogConfirm("R", "ต้องการไม่อนุมัติใบแจ้งฯ หรือไม่")} disabled={disPlayMode()} />
                                <Button
                                    className="p-button-secondary p-button"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก"
                                    // style={{ marginLeft: '5px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => handlerBackPage()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
            </div>
        </>
    );
}
